import { useCallback } from 'react'
import { useBeforeUnload } from 'react-router'

export function useUnsavedChangesWarning(enabled: boolean): void {
  useBeforeUnload(
    useCallback(
      (e: BeforeUnloadEvent) => {
        if (enabled) e.preventDefault()
      },
      [enabled]
    )
  )
}
